<template>
  <!--  ・회원가입 안내-->
  <div v-show="menu === 0">
    <div class="top-navi">
      <div
        v-for="(item, index) in navItem"
        :key="'topNavi' + index"
        :class="['top-navi__item', {selected: item.selected}]"
        @click="onClickNavItem(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div>
      <div v-if="navItem[0].selected === true" class="greet">
        <div v-html="editorContent"></div>
      </div>
      <div v-else-if="navItem[1].selected === true" class="operation">
        <div v-html="editorContent"></div>
      </div>
      <div v-else-if="navItem[2].selected === true">
        <div class="member-selector">
          <div :class="['member-selector__item', {on: companySearchInfo.companyType === '02'}]" @click="changeCompanyType('02')">역대 회원사</div>
          <div :class="['member-selector__item', {on: companySearchInfo.companyType === '01'}]" @click="changeCompanyType('01')">현재 회원사</div>
        </div>
        <div class="member-search">
          <input
            class="member-search__input"
            type="text"
            placeholder="회원사명 입력"
            @keyup.enter="getMembershipCompanyList('search')"
            @input="changeKeyword($event)"
          />
          <div class="member-search__btn cursor" @click="getMembershipCompanyList('search')">검색</div>
        </div>
        <div class="member-korean__nav">
          <div
            v-for="(item, index) in koreanNavItems"
            :key="'korNav' + index"
            :class="['nav-item', {on: item.selected}]"
            @click="changeConsonant(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="member-list">
          <div v-for="company in membershipCompanyList" :key="'comp' + company.id" class="member-list__item">
            {{ company.name }}
          </div>
        </div>
        <Pagination :total-count="companySearchInfo.totalCount" :now-page="companySearchInfo.page" :limit="90" @changePage="membershipChangePage" />
      </div>
      <div v-else-if="navItem[3].selected === true">
        <div v-html="editorContent"></div>
        <div class="join-btn__wrap" style="margin-top: 24px">
          <div class="join-btn cursor" @click="goPayment(true)">신규가입</div>
        </div>
        <MembershipPaymentInfoModal v-if="isPaymentInfoModal" :member-type="memberType" @close="isPaymentInfoModal = false" />
      </div>
    </div>
  </div>
  <div v-show="menu === 1" class="meeting">
    <div v-if="meetingTab === 0">
      <div class="detail-title">
        <div class="is-18b">{{ meetingInfo.title }}</div>
        <div class="sup-btn" @click="onClickApply">당월 참가신청</div>
      </div>
      <div class="info-wrap">
        <div class="info-info">
          <div class="info-item">
            <div class="item-left is-14r">주제 :</div>
            <div class="item-right is-14b blue">{{ meetingInfo.subject }}</div>
          </div>
          <div class="info-item">
            <div class="item-left is-14r">일시 :</div>
            <div class="item-right is-14r">{{ meetingInfo.date }}</div>
          </div>
          <div class="info-item">
            <div class="item-left is-14r">장소 :</div>
            <div class="item-right is-14b">{{ meetingInfo.location }}</div>
          </div>
        </div>
        <div v-html="meetingInfo.content"></div>
      </div>
    </div>
    <div v-else-if="meetingTab === 1">
      <div class="detail-title">
        <div class="ps-18r">한국인사관리자 월례미팅 신청</div>
      </div>
      <div class="sup-wrap">
        <div class="sup-wrap__item">
          <div class="item-left">참가월</div>
          <div class="item-right gray is-14r">
            {{ koreanYearMonth }}
          </div>
        </div>
        <div class="sup-wrap__item">
          <div class="item-left">회사명</div>
          <div class="item-right is-14r">
            <input
              type="text"
              :value="meetingSup.companyName"
              @input="inputMeetingInfo($event, 'companyName')"
              placeholder="회사명을 입력해 주세요"
            />
          </div>
        </div>
        <div v-for="(member, index) in meetingSup.participant" :key="'sup' + index" class="sup-wrap__item">
          <div class="item-left">{{ '참가자' + (index + 1) }}</div>
          <div class="item-right">
            <div class="right-item">
              <div class="right-item__title is-14r">성명</div>
              <input type="text" :value="member.name" @input="inputMeetingInfo($event, 'name', index)" placeholder="성명을 입력해 주세요" />
            </div>
            <div class="right-item">
              <div class="right-item__title is-14r">부서</div>
              <input
                type="text"
                :value="member.department"
                @input="inputMeetingInfo($event, 'department', index)"
                placeholder="부서를 입력해 주세요"
              />
            </div>
            <div class="right-item">
              <div class="right-item__title is-14r">직위</div>
              <input type="text" :value="member.position" @input="inputMeetingInfo($event, 'position', index)" placeholder="직위를 입력해 주세요" />
            </div>
            <div class="right-item">
              <div class="right-item__title is-14r">휴대폰 번호</div>
              <input type="text" :value="member.contact" @input="inputMeetingInfo($event, 'contact', index)" placeholder="행사 2일전 안내문자 발송" />
            </div>
            <!--            <div class="right-item">-->
            <!--              <div class="right-item__title is-14r">이메일</div>-->
            <!--              <input type="text" :value="member.email" @input="inputMeetingInfo($event, 'email', index)" placeholder="이메일을 입력해 주세요" />-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div class="sup-notice is-14r">
        한국인사관리협회 개인정보 수집 및 이용에 대한 안내<br /><br /><br />

        한국인사관리협회 (www.insabank.com 이하 "회사" 또는 "한국인사관리협회"라 함)는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호
        등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보취급방침을
        정하여 이용자 권익 보호에 최선을 다하고 있습니다.
      </div>
      <div class="sup-agree" @click="meetingSup.agree = !meetingSup.agree">
        <div>
          <svg v-if="!meetingSup.agree" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 18.5001C3.34315 18.5001 2 17.1569 2 15.5001V5.5C2 3.84315 3.34315 2.5 5 2.5H15C16.6569 2.5 18 3.84315 18 5.5L18 15.5001C18 17.1569 16.6569 18.5001 15 18.5001H5Z"
              fill="white"
              stroke="#DBDBDB"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg v-else width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 18.5001C3.34315 18.5001 2 17.1569 2 15.5001V5.5C2 3.84315 3.34315 2.5 5 2.5H15C16.6569 2.5 18 3.84315 18 5.5L18 15.5001C18 17.1569 16.6569 18.5001 15 18.5001H5Z"
              fill="#0058AA"
            />
            <path
              d="M12.6667 8.83325L8.19205 12.8333L6.66675 11.4698"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="is-14m">위 사항을 모두 읽었으며 동의합니다.</div>
      </div>
      <div class="sup-btn" @click="supMeeting">신청하기</div>
    </div>
    <MembershipIsClosedModal v-if="isClosedModal" @close="isClosedModal = false" />
  </div>
  <div v-show="menu === 2">
    <!-- 동영상 재생 영역-->
    <div id="onseminar-overlay"></div>
    <!-- 동영상 목록 영역-->
    <div id="onseminar-container"></div>
  </div>
  <div v-show="menu === 3" class="board">
    <div class="detail-title">
      <div v-if="boardDetailHandler" class="title-left">{{ boardTitle.subTitle }}</div>
      <div class="title-right">
        {{ boardTitle.title }}
      </div>
    </div>
    <div class="top-navi">
      <div
        v-for="(item, index) in boardNavItem"
        :key="'boardNavi' + index"
        :class="['top-navi__item', {selected: item.selected}]"
        @click="onClickBoardNavItem(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div v-if="boardList.length > 0" class="list-wrap">
      <div class="list-title">
        <div class="title-item">번호</div>
        <div class="title-item">분류</div>
        <div class="title-item">제목</div>
        <div class="title-item">글쓴이</div>
        <div class="title-item">날짜</div>
        <div class="title-item">조회수</div>
      </div>
      <div v-for="board in boardList" :key="'board' + board.id" class="list-item__wrap" @click="getMembershipDataBoardDetail(board.id)">
        <div class="list-item">{{ board.no }}</div>
        <div class="list-item">{{ board.dataTypeName }}</div>
        <div class="list-item">{{ board.title }}</div>
        <div class="list-item">{{ board.writer }}</div>
        <div class="list-item">{{ board.createdAt }}</div>
        <div class="list-item">{{ board.viewCnt }}</div>
      </div>
      <Pagination
        :total-count="boardSearchInfo.totalCount"
        :now-page="boardSearchInfo.page"
        :limit="20"
        @changePage="boardListChangePage"
        style="margin-top: 32px"
      />
    </div>
  </div>
  <div v-show="menu === 4" class="photo">
    <div class="detail-title">
      <div class="ps-18r">포토존</div>
    </div>
    <div class="photo-list">
      <div class="photo-list__wrap">
        <div v-for="photo in photoList" :key="'photo' + photo.id" class="photo-item" @click="openPhotoModal(photo.id)">
          <img :src="photo.thumbnail" alt="thumbnail" class="thumbnail" />
          <div class="title">{{ photo.title }}</div>
          <div class="content">{{ photo.content }}</div>
        </div>
      </div>
      <Pagination
        :total-count="photoSearchInfo.totalCount"
        :now-page="photoSearchInfo.page"
        :limit="photoSearchInfo.limit"
        @changePage="photoListChangePage"
      />
    </div>
    <PhotoViewModal v-if="photoModal.show" :photo-id="photoModal.photoId" @close="photoModal.show = false" />
  </div>
  <Spinner v-if="isSpinner" />
</template>

<script>
import MembershipPaymentInfoModal from '~/components/membership-business/modal/MembershipPaymentInfoModal.vue'
import MembershipIsClosedModal from '~/components/membership-business/modal/MembershipIsClosedModal.vue'
import PhotoViewModal from '~/components/membership-business/PhotoViewModal.vue'
import Pagination from '~/components/common/Pagination.vue'
import {useMembershipStore} from '~/store/membership'
import {useMemberStore} from '~/store/member'
import {useCommonStore} from '~/store/common'
import Spinner from '~/components/common/loading/Spinner.vue'
import {getKoreanYearMonth} from '~/utils/CommonUtils.js'

export default {
  components: {
    Spinner,
    Pagination,
    PhotoViewModal,
    MembershipPaymentInfoModal,
    MembershipIsClosedModal
  },
  setup() {
    const memberStore = useMemberStore()
    const store = useMembershipStore()
    const commonStore = useCommonStore()
    return {store, memberStore, commonStore}
  },

  props: {
    menu: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isSpinner: false,
      editorContent: '',
      meetingContent: '',
      editorBoardType: '',
      isClosedModal: false,
      isAuth: false,
      memberType: 'MMT01',
      greetData: {
        imgPath: '',
        title: '',
        content: ''
      },
      operation: {
        title: '',
        meetingOperation: '',
        operationSchedule: {
          list: [
            {
              date: '',
              title: ''
            }
          ],
          type: ''
        },
        operationTheme: {
          list: [
            {
              date: '',
              subject: ''
            }
          ]
        },
        themePool: {
          cardBox: [{content: '', subject: ''}]
        },
        yearSchedule: {
          list: [
            {
              day: '',
              month: ''
            }
          ]
        },
        benefit: ''
      },
      navItem: [
        {
          name: '인사말',
          selected: true
        },
        {
          name: '운영방법 및 회원혜택',
          selected: false
        },
        {
          name: '회원사',
          selected: false
        },
        {
          name: '회원가입 신청',
          selected: false
        },
        {
          name: '기존회원 연장가입',
          selected: false
        }
      ],
      companySearchInfo: {
        type: 'MMT01',
        companyType: '02',
        page: 1,
        limit: 90,
        keyword: '',
        consonant: '',
        totalCount: 0
      },
      koreanNavItems: [
        {name: '전체', selected: true},
        {name: '가', selected: false},
        {name: '나', selected: false},
        {name: '다', selected: false},
        {name: '라', selected: false},
        {name: '마', selected: false},
        {name: '바', selected: false},
        {name: '사', selected: false},
        {name: '아', selected: false},
        {name: '자', selected: false},
        {name: '차', selected: false},
        {name: '카', selected: false},
        {name: '타', selected: false},
        {name: '파', selected: false},
        {name: '하', selected: false}
      ],
      membershipCompanyList: [{id: 0, name: ''}],
      memberJoinForm: {
        target: '',
        price: '',
        place: '',
        registerMethod: '',
        account: '',
        contact: ''
      },
      meetingTab: 0,
      meetingSup: {
        companyName: '',
        participant: [
          {
            name: '',
            department: '',
            position: '',
            contact: ''
            // email: ''
          },
          {
            name: '',
            department: '',
            position: '',
            contact: ''
            // email: ''
          },
          {
            name: '',
            department: '',
            position: '',
            contact: ''
            // email: ''
          }
        ],
        agree: false
      },
      koreanYearMonth: '',
      meetingInfo: {
        id: 0,
        title: '',
        subject: '',
        date: '',
        location: '',
        content: {
          list: [
            {
              time: '',
              content: '',
              subject: ''
            }
          ]
        },
        note: '',
        contact: ''
      },
      boardTitle: {
        title: '정보자료',
        subTitle: ''
      },
      boardNavItem: [
        {
          name: '전체',
          selected: true,
          dataType: ''
        },
        {
          name: '연봉실태자료',
          selected: false,
          dataType: 'MDT01'
        },
        {
          name: '강의자료',
          selected: false,
          dataType: 'MDT02'
        },
        {
          name: '기타 조사자료',
          selected: false,
          dataType: 'MDT03'
        }
      ],
      boardSearchInfo: {
        type: 'MMT01',
        dataType: '',
        page: 1,
        limit: 20,
        totalCount: 0
      },
      boardList: [
        {
          no: 0,
          id: 0,
          type: '',
          dataType: '',
          dataTypeName: '',
          title: '',
          writer: '',
          createdAt: '',
          viewCnt: 0
        }
      ],
      boardDetail: {
        id: 0,
        type: '',
        dataType: '',
        dataTypeName: '',
        title: '',
        content: '',
        hasAttachedFiles: 0,
        attachedFiles: [
          {
            'name': '',
            'date': '',
            'url': '',
            'expiresDate': 0
          }
        ]
      },
      boardDetailHandler: false,
      photoList: [
        {
          id: 0,
          title: '',
          content: '',
          thumbnail: ''
        }
      ],
      photoSearchInfo: {
        type: 'MMT01',
        page: 1,
        limit: 9,
        totalCount: 0
      },
      photoModal: {
        show: false,
        photoId: 0
      },
      isPaymentInfoModal: false,
      contact: {
        nameMail: '',
        tel: ''
      },
      isSubscribe: false
    }
  },
  async mounted() {
    this.meetingTab = 0
    // query dataType, page 값이 있을경우
    if (this.$route.query.dataType) {
      this.boardNavItem.forEach(item => {
        item.selected = false
        if (item.dataType === this.$route.query.dataType) {
          item.selected = true
          this.boardTitle.subTitle = item.name
        }
      })
      this.boardSearchInfo.dataType = this.$route.query.dataType
    }
    if (this.$route.query.page) {
      this.boardSearchInfo.page = Number(this.$route.query.page)
    }
    // query 에 apply 가 있는지 확인
    const apply = this.$route.query.apply
    const company = this.$route.query.company
    const menu = this.$route.query.menu
    // 신청탭 으로 이동
    if (apply) {
      if (menu === '2') {
        await this.onClickNavItem(this.navItem[4])
      } else {
        await this.onClickNavItem(this.navItem[3])
      }
      // 회원사 탭으로 이동
    } else if (company) {
      if (menu === '2') {
        await this.onClickNavItem(this.navItem[3])
      } else {
        await this.onClickNavItem(this.navItem[2])
      }
    } else {
      await this.onClickNavItem(this.navItem[0])
    }
    this.isAuth = this.memberStore.isAuthenticated
    if (this.isAuth) {
      await this.getMembershipSubscribe()
      this.onseminarInit()
    }
  },
  watch: {
    // props 의 Menu가 바뀔때마다 실행
    menu: {
      handler() {
        this.membershipDataHandler()
      },
      immediate: true
    },
    // query 의 page, dataType 가 바뀔때마다 실행
    '$route.query': {
      handler() {
        const dataType = this.$route.query.dataType
        const page = this.$route.query.page
        if (dataType || page) {
          this.boardNavItem.forEach(item => {
            item.selected = false
            if (item.dataType === dataType) {
              item.selected = true
              this.boardTitle.subTitle = item.name
            }
          })
          this.boardSearchInfo.dataType = dataType
          this.boardSearchInfo.page = Number(page)
          setTimeout(() => {
            this.getMembershipDataBoardList()
          }, 100)
        }
      },
      immediate: true
    }
  },
  methods: {
    // async getMeetingEditorBoard() {
    //   try {
    //     const payload = {
    //       parentType: 'membership',
    //       type: `04-${this.memberType}`
    //     }
    //     const {data} = await this.commonStore.getEditorBoard(payload)
    //     // 없으면 빈값
    //     // this.editorContent = data.board?.content
    //     this.meetingContent = data.board ? data.board.content : ''
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //   }
    // },
    async getEditorBoard() {
      try {
        this.isSpinner = true
        const payload = {
          parentType: 'membership',
          type: this.editorBoardType
        }
        const {data} = await this.commonStore.getEditorBoard(payload)
        // 없으면 빈값
        // this.editorContent = data.board?.content
        this.editorContent = data.board ? data.board.content : ''
      } catch (error) {
        console.log(error)
      } finally {
        this.isSpinner = false
      }
    },
    async getMembershipSubscribe() {
      try {
        // 구독여부 체크
        const {data} = await this.store.getMembershipSubscribe(this.memberType)
        this.isSubscribe = data.isSubscribe
      } catch (error) {
        console.log(error)
      }
    },
    onClickApply() {
      if (!this.isAuth) {
        alert('로그인 후 이용해주세요.')
        return
      }
      if (this.meetingInfo.isClosed === 0) {
        this.meetingTab = 1
      } else {
        this.isClosedModal = true
      }
    },
    async goPayment(isNew) {
      if (!this.isAuth) {
        alert('로그인 후 이용해주세요.')
        return
      }
      // 기존 가입여부 판단해서 팝업 추가
      if (isNew) {
        try {
          const {data} = await this.store.getMembershipSubscribeHistory(this.memberType)
          const isSubscribed = data.isSubscribed
          if (isSubscribed) {
            this.isPaymentInfoModal = true
          } else {
            this.$router.push(`/membership-business/payment?type=${this.memberType}&isNew=1`)
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        // 기존회원 연장 가입 신청시 현재 구독여부 체크해서 구독중 아닐경우에는 isNew=1 로 보내기
        const {data} = await this.store.getMembershipSubscribe(this.memberType)
        const isSubscribe = data.isSubscribe
        if (isSubscribe) {
          this.$router.push(`/membership-business/payment?type=${this.memberType}&isNew=0`)
        } else {
          this.$router.push(`/membership-business/payment?type=${this.memberType}&isNew=1`)
        }
      }
    },
    async membershipDataHandler() {
      switch (this.menu) {
        case 0:
          // 인사말 조회
          await this.getMembershipGreeting()
          // 회원사 리스트
          await this.getMembershipCompanyList()
          // 회원가입 안내
          await this.getMembershipJoinForm()
          // 운영방법 및 회원혜택
          await this.getMembershipOperation()
          break
        case 1:
          // 미팅정보 조회
          await this.getMembershipMontlyInfo()
          this.koreanYearMonth = getKoreanYearMonth(this.meetingInfo.yearMonth)
          break
        case 2:
          break
        case 3:
          await this.getMembershipDataBoardList()
          break
        case 4:
          await this.getMembershipPhotoBoardList()
          break
      }
    },
    // openPhotoModal
    openPhotoModal(photoId) {
      this.photoModal.photoId = photoId
      this.photoModal.show = true
    },
    async getMembershipPhotoBoardList() {
      try {
        const {data} = await this.store.getMembershipPhotoBoardList(this.photoSearchInfo)
        this.photoList = data.list
        this.photoSearchInfo.totalCount = data.count
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async getMembershipOperation() {
      try {
        const {data} = await this.store.getMembershipOperation(this.memberType)
        this.operation = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async getMembershipMontlyInfo() {
      try {
        const payload = {
          type: this.memberType
        }
        const {data} = await this.store.getMembershipMontlyInfo(payload)
        this.meetingInfo = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    // inputMeetingInfo
    inputMeetingInfo(e, type, index) {
      if (type === 'companyName') {
        this.meetingSup.companyName = e.target.value
      } else if (type === 'contact') {
        this.meetingSup.participant[index][type] = formatPhoneNumber(e.target.value)
      } else {
        this.meetingSup.participant[index][type] = e.target.value
      }
    },
    async supMeeting() {
      // validation
      if (!this.checkSupMeetingValidation()) return

      // MEetingSup members에 모두 빈값인 오브젝트는 삭제
      this.meetingSup.participant = this.meetingSup.participant.filter(member => {
        return member.name !== '' || member.department !== '' || member.position !== '' || member.contact !== ''
      })

      try {
        this.isSpinner = true
        const payload = {
          membershipMonthlyInfoId: this.meetingInfo.id,
          companyName: this.meetingSup.companyName,
          participant: this.meetingSup.participant
        }
        const res = await this.store.postMembershipMonthlyApplication(payload)
        const result = res.result
        // 회원사업 구독일경우에만 신청가능
        if (result.code === 200) {
          alert('신청이 완료되었습니다.')
          // 신청완료 후 초기화
          this.meetingSup.companyName = ''
          this.meetingSup.participant = [
            {
              name: '',
              department: '',
              position: '',
              contact: ''
              // email: ''
            },
            {
              name: '',
              department: '',
              position: '',
              contact: ''
              // email: ''
            },
            {
              name: '',
              department: '',
              position: '',
              contact: ''
              // email: ''
            }
          ]
          this.meetingSup.agree = false
          this.meetingTab = 0
        } else {
          alert(`${result.info}`)
        }
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSpinner = false
      }
    },
    checkSupMeetingValidation() {
      if (!this.meetingSup.agree) {
        alert('개인정보 수집 및 이용에 대한 동의가 필요합니다.')
        return false
      }
      if (!this.meetingSup.companyName) {
        alert('회사명을 입력해주세요.')
        return false
      }

      // 참가자 없는지 확인
      const empthyParticipant = this.meetingSup.participant.filter(member => {
        return member.name === '' && member.department === '' && member.position === '' && member.contact === ''
      })
      if (empthyParticipant.length === 3) {
        alert('참가자 정보가 없습니다.')
        return false
      }

      // meetingSup.participant에 빈값이 있는지 확인
      for (let el of this.meetingSup.participant) {
        // el 의 데이터가 하나라도 들어있는데 빈값도 동시에 있으면 false
        if (el.name || el.department || el.position || el.contact) {
          // // 이메일에 @ 포함 여부 체크
          // if (el.email && !el.email.includes('@')) {
          //   alert('이메일 형식이 올바르지 않습니다.')
          //   return false
          // }

          // 연락처 체크: 숫자만 있는 경우(예: 1234) 방지
          if (el.contact) {
            // 연락처가 단순히 숫자만 있는지 확인
            const isOnlyNumbers = /^\d+$/.test(el.contact)
            if (isOnlyNumbers) {
              alert('휴대폰 번호를 올바르게 입력해주세요.\n(예: 010-1234-5678 )')
              return false
            } else {
              if (el.contact.length < 13) {
                alert('휴대폰 번호를 올바르게 입력해주세요.\n(예: 010-1234-5678 )')
                return false
              }
            }
          }

          // 필수 필드가 모두 채워졌는지 확인
          if (!el.name || !el.department || !el.position || !el.contact) {
            alert('참가자 정보를 모두 입력해주세요.')
            return false
          }
        }
      }
      return true
    },
    onseminarInit() {
      // MMT01 : 한국인사관리자 월례미팅
      // MMT02 : 교육연수담당자 월례미팅
      // MMT03 : 인사팀(부)장 교류회
      // MMT04 : Korea CHO Forum
      const idList = {
        'MMT01': '6c6cd86f-fc34-413c-9068-08b9c54d48df',
        'MMT02': 'f1feea6f-32ff-4024-bde6-6b0231a41c2a',
        'MMT03': '3a802a56-db3e-41c3-8e2d-73770718a660',
        'MMT04': '1f91baea-105b-4af8-9e90-f4de75cd2faf'
      }

      const initOnseminar = () => {
        if (typeof window.onseminar !== 'undefined') {
          try {
            window.onseminar.init({id: idList[this.memberType]})
          } catch (error) {
            console.error('Error initializing onseminar:', error)
          }
        } else {
          console.error('onseminar is not defined after loading the script')
        }
      }

      // 0.25초 후 실행
      setTimeout(initOnseminar, 250)
    },
    // 회원사 페이지네이션 작업
    membershipChangePage(page) {
      this.companySearchInfo.page = page

      this.getMembershipCompanyList()

      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    goBackBoard() {
      this.boardDetailHandler = false
      this.boardTitle.subTitle = ''
      this.boardTitle.title = '정보자료'
    },
    // 정보자료 페이지네이션 작업
    boardListChangePage(page) {
      this.boardSearchInfo.page = page

      this.getMembershipDataBoardList()

      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    // 정보자료 페이지네이션 작업
    photoListChangePage(page) {
      this.photoSearchInfo.page = page
      this.getMembershipPhotoBoardList()

      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    // 회원사 목록 조회
    async getMembershipCompanyList(type) {
      if (type === 'search') {
        this.companySearchInfo.page = 1
      }

      try {
        // this.isSpinner = true
        const {data} = await this.store.getMembershipCompanyList(this.companySearchInfo)
        this.companySearchInfo.totalCount = data.count
        this.membershipCompanyList = data.list
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        // this.isSpinner = false
      }
    },
    // 정보자료 게시글 리스트 조회
    async getMembershipDataBoardList() {
      try {
        // this.isSpinner = true
        const {data} = await this.store.getMembershipDataBoardList(this.boardSearchInfo)
        this.boardSearchInfo.totalCount = data.count
        this.boardList = data.list

        this.$router.push(`/membership-business?menu=0&subMenu=3&dataType=${this.boardSearchInfo.dataType}&page=${this.boardSearchInfo.page}`)
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        // this.isSpinner = false
      }
    },
    // 정보자료 게시글 detail 조회
    getMembershipDataBoardDetail(id) {
      if (!this.isAuth) {
        alert('로그인 후 이용해주세요.')
        return
      }
      if (!this.isSubscribe) {
        alert('회원사업 가입 후 이용 가능합니다.')
        return
      }
      const urlParams = new URLSearchParams(window.location.search)
      const menuIndex = parseInt(urlParams.get('menu') || '0')
      const subMenuIndex = parseInt(urlParams.get('subMenu') || '0')
      this.$router.push(
        `/membership-business/board/${id}?menu=${menuIndex}&subMenu=${subMenuIndex}&dataType=${this.boardSearchInfo.dataType}&page=${this.boardSearchInfo.page}`
      )
    },
    // 회원가입안내 상단 네비 메뉴
    async onClickNavItem(item) {
      if (item.name === '기존회원 연장가입') {
        await this.goPayment(false)
        return
      }
      if (item.name === '인사말') {
        this.editorBoardType = `01-${this.memberType}`
      } else if (item.name === '운영방법 및 회원혜택') {
        this.editorBoardType = `02-${this.memberType}`
      } else if (item.name === '회원가입 신청') {
        this.editorBoardType = `03-${this.memberType}`
      }
      if (item) {
        this.navItem.forEach(navItem => {
          navItem.selected = false
        })
        item.selected = true
      }
      await this.getEditorBoard()
    },
    // 정보자료 상단 네비 메뉴
    onClickBoardNavItem(item) {
      if (item) {
        this.boardNavItem.forEach(navItem => {
          navItem.selected = false
        })
        item.selected = true
      }
      this.boardSearchInfo.dataType = item.dataType
      this.boardSearchInfo.page = 1
      this.getMembershipDataBoardList()
    },
    // 가나다순 정력
    changeConsonant(item) {
      this.companySearchInfo.consonant = item.name
      item.selected = true
      // 나머지 아이템은 다 False
      this.koreanNavItems.forEach(navItem => {
        if (navItem.name !== item.name) {
          navItem.selected = false
        }
      })
      if (item.name === '전체') this.companySearchInfo.consonant = ''
      this.companySearchInfo.page = 1
      this.getMembershipCompanyList()
    },
    // 회원사 컴퍼니타입 변경
    changeCompanyType(type) {
      this.companySearchInfo.companyType = type
      this.companySearchInfo.page = 1
      this.getMembershipCompanyList()
    },
    // 회원사 검색어 입력
    changeKeyword(e) {
      this.companySearchInfo.keyword = e.target.value
    },
    async getMembershipJoinForm() {
      try {
        const {data} = await this.store.getMembershipJoinForm(this.memberType)
        this.memberJoinForm = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    // 인사말 조회
    async getMembershipGreeting() {
      try {
        const {data} = await this.store.getMembershipGreeting(this.memberType)
        this.greetData = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    }
  }
}
</script>

<style scoped lang="scss">
//・회원가입 안내
.top-navi {
  border-top: 1px solid #dbdbdb;
  border-bottom: 1px solid #dbdbdb;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .top-navi__item {
    padding: 18px 16px;
    color: #606060;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    cursor: pointer;

    &:hover {
      color: #0058aa;
    }

    &.selected {
      font-weight: 700;
      color: #0058aa;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 3px;
        background: #0058aa;
      }
    }
  }
}

// 인사말
.greet {
  .greet-img {
    margin-bottom: 24px;

    img {
      height: 255px;
    }
  }

  .greet-title {
    border-bottom: 1px solid #dbdbdb;
    padding-bottom: 24px;
    margin-bottom: 24px;

    .is-18b {
      color: #0058aa;
      white-space: pre-line;
      font-family: 'Godo', sans-serif;
    }
  }

  .greet-content {
    column-count: 2;
    column-gap: 24px;
    max-height: 448px;
    overflow: auto;

    .is-14r {
      white-space: pre-line;
      break-inside: avoid-column;
      margin-bottom: 24px;
    }
  }
}

// 운영방법 및 회원혜택
.operation {
  .detail-title {
    margin-bottom: 24px;
  }

  .meeting-operation {
    padding-left: 24px;
    margin-bottom: 24px;
    white-space: pre-line;
  }

  .operation-schedule {
    margin-bottom: 24px;

    .schedule-wrap {
      border: 1px solid #dbdbdb;

      display: flex;

      .schedule-type {
        background: #fbfbfb;
        border-right: 1px solid #dbdbdb;
        width: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .schedule-list__wrap {
        .schedule-list {
          border-bottom: 1px solid #dbdbdb;
          display: flex;
          min-height: 48px;

          .schedule-date {
            border-right: 1px solid #dbdbdb;
            width: 247px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .schedule-title {
            width: 383px;
            display: flex;
            padding: 16px;
          }

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }

  .operation-theme {
    margin-bottom: 24px;

    .detail-title {
      margin-bottom: 24px;
    }

    .theme-wrap {
      border: 1px solid #dbdbdb;
    }

    .theme-list {
      display: flex;
      border-bottom: 1px solid #dbdbdb;

      &:last-child {
        border-bottom: 0;
      }

      .is-14m {
        background: #fbfbfb;
      }

      .list-left {
        padding: 16px;
        flex: 0.9;
        justify-content: center;
        border-right: 1px solid #dbdbdb;
        display: flex;
      }

      .list-right {
        padding: 16px;
        flex: 2;
      }
    }
  }

  .theme-pool {
    margin-bottom: 24px;

    .temme-pool__wrap {
      flex-wrap: wrap;
      gap: 24px;
      display: flex;
      margin-bottom: 16px;

      .theme-card {
        display: flex;
        flex-direction: column;
        flex: 0.5;
        border: 1px solid #dbdbdb;

        .card-subject {
          padding: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          background: #0058aa;
        }

        .card-content {
          white-space: pre-line;
          padding: 10px 24px;
        }
      }
    }
  }

  .benefit {
    margin-bottom: 24px;

    .detail-title {
      margin-bottom: 24px;
    }

    .is-14r {
      white-space: pre-line;
      border: 1px solid #dbdbdb;
      padding: 24px;
    }
  }
}

.member-selector {
  display: flex;
  border: 1px solid #dbdbdb;
  margin-bottom: 24px;

  .member-selector__item {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;

    &.on {
      background: #0058aa;
      color: #fff;
    }
  }
}

.member-search {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;

  .member-search__input {
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: var(--Color-Base-white, #fff);
    padding: 9px 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    width: 100%;

    &::placeholder {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      color: #909090;
    }
  }

  .member-search__btn {
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: #f2f2f2;
    min-width: 48px;
    display: flex;
    align-items: center;
    color: #212121;
    justify-content: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
  }
}

.member-korean__nav {
  display: flex;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 12px;

  .nav-item {
    width: 48px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606060;
    position: relative;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      color: #0058aa;
    }

    &.on {
      color: #0058aa;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 3px;
        background: #0058aa;
      }
    }
  }
}

.member-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 32px;

  .member-list__item {
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    align-items: center;
    width: 240px;
    height: 48px;
    padding: 12px;
    color: #606060;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 17.5px */
  }
}

.join-wrap {
  border: 1px solid #dbdbdb;
  margin-bottom: 24px;
  overflow: hidden;

  .join-item {
    display: flex;
    border-bottom: 1px solid #dbdbdb;

    &:last-child {
      border-bottom: 0;
    }
  }

  .join-item__title {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    padding: 15px;
    flex: 1;
    border-right: 1px solid #dbdbdb;
    background: #fbfbfb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .join-item__desc {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    padding: 15px;
    flex: 2.5;
    white-space: pre-line;
  }
}

.join-btn__wrap {
  display: flex;
  gap: 16px;
  width: 100%;

  .join-btn {
    width: 100%;
    border-radius: 4px;
    background: #0058aa;
    color: #fff;
    padding: 14px;
    text-align: center;
  }
}

.meeting {
  .detail-title {
    margin-bottom: 24px;

    .is-18b {
      color: #0058aa;
      font-family: 'Godo', sans-serif;
    }
  }

  .info-wrap {
    margin-left: 24px;

    .info-info {
      margin-bottom: 24px;

      .info-item {
        display: flex;
        gap: 4px;

        .item-left {
        }

        .item-right {
          &.blue {
            color: #0058aa;
          }
        }
      }
    }

    .info-table {
      border: 1px solid #dbdbdb;
      margin-bottom: 24px;

      .info-table__item {
        display: flex;
        border-bottom: 1px solid #dbdbdb;
        min-height: 48px;

        &.title {
          background: #fbfbfb;
        }

        &:last-child {
          border-bottom: 0;
        }

        .item-one {
          flex: 1.2;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid #dbdbdb;
        }

        .item-two {
          flex: 1.6;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid #dbdbdb;
        }

        .item-three {
          flex: 4.2;
          display: flex;
          align-items: center;
          padding: 16px;
          white-space: pre-line;
        }
      }
    }

    .info-notice {
      margin-bottom: 24px;

      .is-16r {
        white-space: pre-line;

        &:nth-child(3) {
          margin-top: 24px;
        }
      }
    }
  }

  .sup-wrap {
    border: 1px solid #dbdbdb;
    margin-top: 24px;
    margin-bottom: 24px;

    .sup-wrap__item {
      display: flex;
      border-bottom: 1px solid #dbdbdb;

      &:last-child {
        border-bottom: 0;
      }

      .item-left {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        background: #fbfbfb;
        border-right: 1px solid #dbdbdb;
        width: 80px;
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .item-right {
        padding: 16px;
        display: flex;

        input {
          font-size: 14px;
          font-weight: 400;

          &::placeholder {
            color: #909090;
            font-size: 14px;
            font-weight: 400;
          }
        }

        &.gray {
          width: 782px;
          background: #fbfbfb;
        }

        .right-item {
          .right-item__title {
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  .sup-notice {
    padding: 16px;
    border: 1px solid #dbdbdb;
    margin-bottom: 16px;
  }

  .sup-agree {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    margin-bottom: 24px;
  }

  .sup-btn {
    border-radius: 4px;
    background: #0058aa;
    color: #fff;
    padding: 14px;
    text-align: center;
    cursor: pointer;
  }
}

.board {
  .back-btn {
    margin-bottom: 33px;
    color: #909090;
    cursor: pointer;
  }

  .detail-title {
    justify-content: flex-start;
    gap: 16px;

    .title-left {
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      color: #606060;
      font-family: 'Godo', sans-serif;
    }

    .title-right {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      color: #0058aa;
      font-family: 'Godo', sans-serif;
    }
  }

  .board-detail {
    margin-bottom: 24px;

    .detail-content {
      padding: 24px;
      white-space: pre-line;
    }

    .detail-files {
      border-top: 1px solid #dbdbdb;
      border-bottom: 1px solid #dbdbdb;
      background: #fbfbfb;
      padding: 12px 24px;
      display: flex;
      gap: 16px;

      .files-right {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .file-item {
          cursor: pointer;
          display: flex;
          gap: 4px;
        }
      }
    }
  }

  .list-wrap {
    margin-top: 24px;

    .list-title {
      display: flex;
      border-bottom: 1px solid #909090;
      background: #fbfbfb;
      height: 38px;

      .title-item {
        display: flex;
        align-items: center;
        padding-left: 4px;
        justify-content: flex-start;
        color: #606060;
        font-size: 12px;
        font-weight: 500;

        &:first-child {
          min-width: 66px;
        }

        &:nth-child(2) {
          min-width: 97px;
        }

        &:nth-child(3) {
          min-width: 335px;
        }

        &:nth-child(4) {
          min-width: 68px;
        }

        &:nth-child(5) {
          min-width: 104px;
        }

        &:last-child {
          min-width: 60px;
        }
      }
    }

    .list-item__wrap {
      display: flex;
      cursor: pointer;

      .list-item {
        display: flex;
        font-size: 12px;
        font-weight: 400;
        align-items: center;
        justify-content: flex-start;
        padding-left: 4px;
        border-bottom: 1px solid #dbdbdb;

        &:first-child {
          min-width: 66px;
        }

        &:nth-child(2) {
          min-width: 97px;
        }

        &:nth-child(3) {
          justify-content: flex-start;
          min-width: 335px;
          font-size: 13px;
          padding: 16px;
        }

        &:nth-child(4) {
          min-width: 68px;
        }

        &:nth-child(5) {
          min-width: 104px;
        }

        &:last-child {
          min-width: 60px;
        }
      }
    }
  }
}

.photo {
  .detail-title {
    margin-bottom: 24px;
  }

  .photo-list {
    .photo-list__wrap {
      margin-bottom: 32px;
      display: flex;
      gap: 24px;
      flex-wrap: wrap;

      .photo-item {
        width: 222px;
        cursor: pointer;

        .thumbnail {
          height: 124px;
          margin-bottom: 16px;
          width: 100%;
          object-fit: cover;
        }

        .title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
        }

        .content {
          color: #909090;
          font-family: Pretendard;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
